/* ============
 * Product Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';

export default class WarehouseTransactionTransformer extends Transformer {

  static fetch(transaction) {
    return {
      id: transaction.id,
      transactionId: transaction.transaction_id,
      code: transaction.code,
      via: transaction.via,
      parentModelId: transaction.parent_model_id,
      customerName: transaction.customer_name,
      productName: transaction.product_name,
      beforeQty: transaction.before_qty,
      adjustmentQty: transaction.adjustment_qty,
      afterQty: transaction.after_qty,
      status: transaction.status,
      createdAt: transaction.created_at,
      warehouse: transaction.warehouse,
      billingNumber: transaction.billing_number,
      client: transaction.client,
      batchName: transaction.batch_name,
    };
  }

  static send(transaction) {
    return {
      id: transaction.id,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/warehouseTransactionV2.js